import { useEffect, useState } from 'react';

export const useElementHasFocus = (elementId: string, dependancies: any[] = []) => {
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    const onFocusIn = () => setHasFocus(true);
    const onFocusOut = () => setHasFocus(false);
    const formElement = document.getElementById(elementId);
    formElement?.addEventListener('focusin', onFocusIn);
    formElement?.addEventListener('focusout', onFocusOut);

    return () => {
      formElement?.removeEventListener('focusin', onFocusIn);
      formElement?.removeEventListener('focusout', onFocusOut);
    };
    // Spreading causes a warning in the dependancy array, but we still want to
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [elementId, ...dependancies]);

  return hasFocus;
};
